import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { OrderRuleAudit } from 'src/app/shared/models/order-rule-audit.model';


@Component({
    selector: 'app-rule-violation-modal',
    templateUrl: './rule-violation-modal.component.html',
    styleUrls: ['./rule-violation-modal.component.scss'],
    standalone: false
})
export class RuleViolationModalComponent implements OnInit {
  
  @Input() ruleViolations: OrderRuleAudit;
  @Input() orderId: number;

  constructor(
    private activeModal: NgbActiveModal
    ) { }

  ngOnInit(): void {
  }

  closeModal() {
    this.activeModal.close();
  }
}
